import { eventChannel } from 'redux-saga';
import { isMobile } from 'react-device-detect';

export enum VideoEvents {
  PLAYING = 'playing',
  PLAY = 'play',
  PAUSE = 'pause',
  CANPLAY = 'canplay',
  CANPLAYTHROUGH = 'canplaythrough',
  LOADEDDATA = 'loadeddata',
  PROGRESS = 'progress',
  ENDED = 'ended',
  TIMEUPDATE = 'timeupdate',
  ERROR = 'error',
  WAITING = 'waiting',
  SEEKED = 'seeked',
  SEEKING = 'seeking',
  EMPTIED = 'emptied', // Fired when the media has become empty
}

export function videoPlaybackEvents() {
  const videoEl: HTMLVideoElement = document.getElementById('videoEl') as HTMLVideoElement;
  return eventChannel(emitter => {
    const interval = setInterval(() => {
      if (videoEl && !videoEl.paused && videoEl.src) emitter({ type: 'timeupdate' });
    }, 100);
    videoEl.addEventListener(VideoEvents.PLAYING, emitter);
    videoEl.addEventListener(VideoEvents.PAUSE, emitter);
    videoEl.addEventListener(VideoEvents.PLAY, emitter);
    videoEl.addEventListener(VideoEvents.CANPLAY, emitter);
    videoEl.addEventListener(VideoEvents.CANPLAYTHROUGH, emitter);
    videoEl.addEventListener(VideoEvents.LOADEDDATA, emitter);
    videoEl.addEventListener(VideoEvents.PROGRESS, emitter);
    videoEl.addEventListener(VideoEvents.ENDED, emitter);
    videoEl.addEventListener(VideoEvents.TIMEUPDATE, emitter);
    videoEl.addEventListener(VideoEvents.ERROR, emitter);
    videoEl.addEventListener(VideoEvents.WAITING, emitter);
    videoEl.addEventListener(VideoEvents.SEEKED, emitter);
    videoEl.addEventListener(VideoEvents.SEEKING, emitter);
    videoEl.addEventListener(VideoEvents.EMPTIED, emitter);

    return () => {
      clearInterval(interval);
      videoEl.removeEventListener(VideoEvents.PLAYING, emitter);
      videoEl.removeEventListener(VideoEvents.PAUSE, emitter);
      videoEl.removeEventListener(VideoEvents.PLAY, emitter);
      videoEl.removeEventListener(VideoEvents.CANPLAY, emitter);
      videoEl.removeEventListener(VideoEvents.CANPLAYTHROUGH, emitter);
      videoEl.removeEventListener(VideoEvents.LOADEDDATA, emitter);
      videoEl.removeEventListener(VideoEvents.PROGRESS, emitter);
      videoEl.removeEventListener(VideoEvents.ENDED, emitter);
      videoEl.removeEventListener(VideoEvents.TIMEUPDATE, emitter);
      videoEl.removeEventListener(VideoEvents.ERROR, emitter);
      videoEl.removeEventListener(VideoEvents.WAITING, emitter);
      videoEl.removeEventListener(VideoEvents.SEEKED, emitter);
      videoEl.removeEventListener(VideoEvents.SEEKING, emitter);
      videoEl.removeEventListener(VideoEvents.EMPTIED, emitter);
    };
  });
}

export function dashPlayerEvents(DashPlayer, MediaPlayer) {
  return eventChannel(emitter => {
    for (const event in MediaPlayer.events) DashPlayer.on(MediaPlayer.events[event], emitter);
    return () => {
      for (const event in MediaPlayer.events) DashPlayer.off(MediaPlayer.events[event], emitter);
    };
  });
}

export function videoClickEvent(pause) {
  return eventChannel(emitter => {
    function playVideo() {
      videoPlayOnInteraction(pause, emitter);
    }
    if (isMobile) document.addEventListener('touchstart', playVideo, { once: true });
    else document.addEventListener('click', playVideo, { once: true });

    return () => {
      document.removeEventListener('touchstart', playVideo);
      document.removeEventListener('click', playVideo);
    };
  });
}

export async function videoPlayOnInteraction(paused, callback) {
  const videoEl: any = document.getElementById('videoEl');
  videoEl.setAttribute('muted', true);
  const hasSource = videoEl.getAttribute('src') != null;

  if (!hasSource) videoEl.setAttribute('src', '');

  try {
    const playPromise = videoEl.play();

    if (playPromise !== undefined)
      playPromise
        .then(async () => {
          videoEl.removeAttribute('muted');
          if (paused) await videoEl.pause();
          if (callback) callback(true);
        })
        .catch(e => {
          videoEl.removeAttribute('muted');
          if (callback) callback(true);
        });
  } catch (e) {
    console.log(e);

    if (paused) await videoEl.pause();
    if (callback) callback(true);
  }
}
